
export const allTenants = [
		{
			subDomain: "benenden",
			typeName: "Benenden",
			codeName: "TENANT.BENENDEN",
			internalName: "Benenden",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./Benenden/Benenden")
		},
		{
			subDomain: "cadogan",
			typeName: "Cadogan",
			codeName: "TENANT.CADOGAN",
			internalName: "Cadogan",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./Cadogan/Cadogan")
		},
		{
			subDomain: "chelwestprivatecare",
			typeName: "ChelWestPpu",
			codeName: "TENANT.CHELWESTPPU",
			internalName: "ChelWestPPU",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./ChelWestPpu/ChelWestPpu")
		},
		{
			subDomain: "circle",
			typeName: "Circle",
			codeName: "TENANT.CIRCLE",
			internalName: "Circle",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./Circle/Circle")
		},
		{
			subDomain: "ccl",
			typeName: "ClevelandClinic",
			codeName: "TENANT.CCL",
			internalName: "ClevelandClinicLondon",
			disabledZones: [
				],
			loginsDisabledAfter: "2026-09-26T00:00:00.0000000",
			importer: () => import("./ClevelandClinic/ClevelandClinic")
		},
		{
			subDomain: "genesiscare",
			typeName: "GenesisCare",
			codeName: "TENANT.GENESISCARE",
			internalName: "GenesisCare",
			disabledZones: [
				"production",
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./GenesisCare/GenesisCare")
		},
		{
			subDomain: "hcauk",
			typeName: "Hca",
			codeName: "TENANT.HCA",
			internalName: "HCA",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./Hca/Hca")
		},
		{
			subDomain: "hje",
			typeName: "Hje",
			codeName: "TENANT.HJE",
			internalName: "HJE",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./Hje/Hje")
		},
		{
			subDomain: "horderhealthcare",
			typeName: "Horder",
			codeName: "TENANT.HORDER",
			internalName: "Horder Healthcare",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./Horder/Horder")
		},
		{
			subDomain: "pbc",
			typeName: "IpsenPbc",
			codeName: "TENANT.IPSENPBC",
			internalName: "IpsenPbc",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./IpsenPbc/IpsenPbc")
		},
		{
			subDomain: "lillyepromsbreastcancer",
			typeName: "LillyBreastCancer",
			codeName: "TENANT.LILLYBREASTCANCER",
			internalName: "Lilly Breast Cancer",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./LillyBreastCancer/LillyBreastCancer")
		},
		{
			subDomain: "lillyepromsibd",
			typeName: "LillyIbd",
			codeName: "TENANT.LILLYIBD",
			internalName: "Lilly IBD",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./LillyIbd/LillyIbd")
		},
		{
			subDomain: "mhg",
			typeName: "Mhg",
			codeName: "TENANT.MHG",
			internalName: "MHG",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./Mhg/Mhg")
		},
		{
			subDomain: "nhssussex",
			typeName: "NhsSussex",
			codeName: "TENANT.NHSSUSSEX",
			internalName: "NHS Sussex",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./NhsSussex/NhsSussex")
		},
		{
			subDomain: "rcht",
			typeName: "Rcht",
			codeName: "TENANT.RCHT",
			internalName: "RCHT",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./Rcht/Rcht")
		},
		{
			subDomain: "royalsurrey",
			typeName: "RoyalSurrey",
			codeName: "TENANT.ROYALSURREY",
			internalName: "Royal Surrey",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./RoyalSurrey/RoyalSurrey")
		},
		{
			subDomain: "signatureclinic",
			typeName: "SignatureClinic",
			codeName: "TENANT.SIGNATURECLINIC",
			internalName: "Signature Clinic",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./SignatureClinic/SignatureClinic")
		},
		{
			subDomain: "spencerprivatehospitals",
			typeName: "SpencerPrivateHospitals",
			codeName: "TENANT.SPENCER",
			internalName: "Spencer",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./SpencerPrivateHospitals/SpencerPrivateHospitals")
		},
		{
			subDomain: "spire",
			typeName: "Spire",
			codeName: "TENANT.SPIRE",
			internalName: "Spire",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./Spire/Spire")
		},
		{
			subDomain: "stjosephs",
			typeName: "StJosephs",
			codeName: "TENANT.STJOSEPHS",
			internalName: "St Joseph's",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./StJosephs/StJosephs")
		},
		{
			subDomain: "tlc",
			typeName: "Tlc",
			codeName: "TENANT.TLC",
			internalName: "TLC",
			disabledZones: [
				],
			loginsDisabledAfter: "9999-12-31T23:59:59.9999999",
			importer: () => import("./Tlc/Tlc")
		},
] as const